export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=0d96b46c&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/QuotesTracking/index.vue?vue&type=template&id=0d96b46c&scoped=true
// module id = 2429
// module chunks = 31